import { render, staticRenderFns } from "./text-tag.mpx?vue&type=template&id=ca4374f2&scoped=true&component=true&componentId=text-tagfef5a77c"
import script from "./text-tag.mpx?vue&type=script&lang=js&component=true&componentId=text-tagfef5a77c"
export * from "./text-tag.mpx?vue&type=script&lang=js&component=true&componentId=text-tagfef5a77c"
import style0 from "./text-tag.mpx?vue&type=style&index=0&id=ca4374f2&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22mfef5a77c%22%7D&component=true&componentId=text-tagfef5a77c"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4374f2",
  null
  
)

export default component.exports